import { render, staticRenderFns } from "./roomBindOwnerList.vue?vue&type=template&id=31fe00d0&scoped=true"
import script from "./roomBindOwnerList.vue?vue&type=script&lang=js"
export * from "./roomBindOwnerList.vue?vue&type=script&lang=js"
import style0 from "./roomBindOwnerList.vue?vue&type=style&index=0&id=31fe00d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fe00d0",
  null
  
)

export default component.exports